/*
 * @Author: Chao Yang
 * @Date: 2020-05-20 09:21:43
 * @LastEditor: Chao Yang
 * @LastEditTime: 2022-04-12 13:16:57
 */

import {
  Component,
  OnInit,
  Input,
  ContentChildren,
  TemplateRef,
} from '@angular/core';

@Component({
  selector: 'ad-expansion-item',
  templateUrl: './ad-expansion-item.component.html',
  styleUrls: ['./ad-expansion-item.component.css'],
})
export class AdExpansionItemComponent implements OnInit {
  @ContentChildren(AdExpansionItemComponent)
  children: AdExpansionItemComponent[] = [];
  @Input() expand = false;
  @Input() title: string;
  @Input() leaf = false;
  @Input() data: any;
  @Input() indentation: number = 0;

  @Input() headerRightTpl: TemplateRef<any>;

  constructor() { }

  ngOnInit() { }

  expandChildren(event: Event) {
    if (this.children == null || this.children.length === 0 || this.leaf) {
      this.expand = false;
      return;
    }
    this.expand = !this.expand;
    event.stopPropagation();
  }

  getStyle() {
    if (this.indentation > 0) {
      return {
        'margin-left': this.indentation + 'px'
      };
    }
    return {};
  }
}
